(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ara-p-burbujas"] && !Shopify.designMode) return;
  try {
    class AraBurbujas extends HTMLElement {
    connectedCallback() {
      var self = this;
      var vp = this.querySelector('[data-vp]');
      var dlg = this.querySelector('dialog');
      /* Los bordes se difuminan solo del lado donde quedan burbujas por ver */
      this._bordes = function () {
        var izq = vp.scrollLeft > 2;
        var der = vp.scrollLeft + vp.clientWidth < vp.scrollWidth - 2;
        vp.style.setProperty('--ara-bur-fi', izq ? '28px' : '0px');
        vp.style.setProperty('--ara-bur-fd', der ? '28px' : '0px');
      };
      vp.addEventListener('scroll', this._bordes, { passive: true });
      window.addEventListener('resize', this._bordes, { passive: true });
      this._bordes();
      if (!dlg || !dlg.showModal) return;
      var img = dlg.querySelector('[data-dlg-img]');
      var tx = dlg.querySelector('[data-dlg-t]');
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-grande]');
        if (b && self.contains(b)) {
          img.src = b.getAttribute('data-grande');
          img.alt = b.getAttribute('data-texto') || '';
          tx.textContent = b.getAttribute('data-texto') || '';
          dlg.showModal();
          return;
        }
        if (e.target.closest('[data-x]') || e.target === dlg) dlg.close();
      });
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this._bordes);
    }
  }
  if (!customElements.get('ara-burbujas')) customElements.define('ara-burbujas', AraBurbujas);
  } catch(e) { console.error(e); }
})();

})();
